// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --header-height: 60px;
}
.element {
  width: 100%;
  padding: 10px;

}


/* Tablet */
@media (min-width: 768px) {
  .element {
    width: 50%;
    padding: 15px;
  }
  .App-content{
    max-width: 100%;
    padding: 0% 6%;
  }
  .Form{
    padding: 0 6%;
    border-style:groove;
  }
}

/* Desktop */
@media (min-width: 1024px) {
  .element {
    width: 33.33%;
    padding: 20px;
  }
  .App-content{
    max-width: 100%;
    padding: 0% 6%;
  }
  .Form{
    padding: 0 6%;
    border-style:groove;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,aAAa;;AAEf;;;AAGA,WAAW;AACX;EACE;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA,YAAY;AACZ;EACE;IACE,aAAa;IACb,aAAa;EACf;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;AACF","sourcesContent":[":root {\n  --header-height: 60px;\n}\n.element {\n  width: 100%;\n  padding: 10px;\n\n}\n\n\n/* Tablet */\n@media (min-width: 768px) {\n  .element {\n    width: 50%;\n    padding: 15px;\n  }\n  .App-content{\n    max-width: 100%;\n    padding: 0% 6%;\n  }\n  .Form{\n    padding: 0 6%;\n    border-style:groove;\n  }\n}\n\n/* Desktop */\n@media (min-width: 1024px) {\n  .element {\n    width: 33.33%;\n    padding: 20px;\n  }\n  .App-content{\n    max-width: 100%;\n    padding: 0% 6%;\n  }\n  .Form{\n    padding: 0 6%;\n    border-style:groove;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
